import {
  anUpdateRuleTuningExpressionEnabled,
  mockUpdateRuleTuningExpressionEnabledOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockUpdateRuleTuningExpressionEnabledOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateRuleTuningExpressionEnabled:
            anUpdateRuleTuningExpressionEnabled(),
        },
      });
    }
  ),
];
